import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Formik, Field } from "formik";
import { connect, useDispatch } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { Input } from "../../../../_metronic/_partials/controls";
import * as auth from "../_redux/authRedux";
import { login, generateOTP, verifyOTP } from "../_redux/authCrud";
import jwt_decode from "jwt-decode";
import { Modal } from "react-bootstrap";
import OtpInput from 'react-otp-input';
//import { id } from "date-fns/locale";
//import { Component} from 'react';

function toastDev(toast) {
  return (
    <div style={{ padding: 40 }}>
      {/* toast display */}
      {toast && (
        <div
          style={{
            position: "fixed",
            bottom: "30px",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#333",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "6px",
            fontSize: "14px",
            zIndex: 9999,
            opacity: 0.95,
          }}
        >
          {toast}
        </div>
      )}
    </div>
  );
}

function Login(props) {

  const dispatch = useDispatch()
  const [toast, setToast] = useState("");
  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [OTP, setOTP] = useState("");
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorOTP, setErrorOTP] = useState(false);
  const [currentUser, setcurrentUser] = useState('');
  //const [emptyOTP, setEmptyOTP] = useState(false);
  const [loading1, setLoading1] = useState(false)

  const [passwordShown, setPasswordShown] = useState(false);

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(""), 5000);
  };
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = (meta, fieldname) => {
    let result = "form-control form-control-solid h-auto py-5 px-6 ";
    if (meta.touched && meta.error) {
      result += " is-invalid"
    }

    if (meta.touched && !meta.error) {
      result += " is-valid"
    }

    return result;
  }


  const CancelFunction = async () => {
    setIsShow(false)
    setErrorOTP(false);
    setOTP("");
    setToast("");

  }

  const ApplySettingFunction = async () => {
    let user = jwt_decode(currentUser);
    setLoading1(true)
    let verify = await verifyOTP(user, OTP);
    if (verify.data.data === true) {
      setErrorOTP(false);
      setLoading1(false)
      disableLoading();
      props.login(currentUser);
      dispatch(auth.actions.fulfillUser(user))
    }
    else {
      setErrorOTP(true);
      setLoading1(false)
    }
  }

  return (

    <>

      <div className="login-form login-signin">
        {/* begin::Head */}
        <div className="text-center mb-10 mb-lg-20">
          {/* https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage */}
          {/* <h3 className="font-size-h1"><FormattedMessage id="AUTH.LOGIN.TITLE"/></h3> */}
          <h3 className="font-size-h1">WELCOME</h3>
          <p className="text-muted font-weight-bold">Sign in to Continue</p>
        </div>
        {/* end::Head */}

        {/*begin::Form*/}

        <Formik
          initialValues={{
            email: "",
            password: ""
          }}
          validate={values => {
            const errors = {};

            if (!values.email) {
              // https://github.com/formatjs/react-intl/blob/master/docs/API.md#injection-api
              errors.email = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
            ) {
              errors.email = intl.formatMessage({
                id: "AUTH.VALIDATION.INVALID_FIELD"
              });
            }

            if (!values.password) {
              errors.password = intl.formatMessage({
                id: "AUTH.VALIDATION.REQUIRED_FIELD"
              });
            }

            return errors;
          }}

          onSubmit={(values, { setStatus, setSubmitting }) => {

            enableLoading();
            setEmail(values.email)
            setPassword(values.password)

            setSubmitting(false);

            setTimeout(async () => {
              let responseLogin = await login(values.email, values.password)
              if (responseLogin.success) {

                let user = jwt_decode(responseLogin.accessToken);
                setcurrentUser(responseLogin.accessToken)
                const responseOTP = await generateOTP(user);
                try {
                  const otp = responseOTP.data.data.Attributes
                    .otp;
                  if (otp && process.env.REACT_APP_NODE_ENV === "development") {
                    showToast(`OTP is ${otp}`)
                  }
                } finally { }
                disableLoading();
                setIsShow(true)
              }
              else {
                //failure
                disableLoading();
                setSubmitting(false);
                setStatus(
                  responseLogin.error.message
                );
              }
            }, 1000);

          }}
        >
          {({
            values,
            status,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting
          }) => (
            <form
              className="form"
              noValidate={true}
              autoComplete="off"
              onSubmit={handleSubmit}
            >
              {status ? (
                <div role="alert" className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                  <div className="alert-text font-weight-bold">{status}</div>
                </div>
              ) : (
                ''
              )}

              <div className="form-group">

                <p className=" font-weight-bold">User Name</p>
                <Field
                  name="email"
                  component={Input}
                  placeholder="Email"
                  label="Email"
                >
                  {({ field, form, meta }) => (
                    <div>
                      <input
                        type="email" {...field}
                        className={`${getInputClasses(meta)}`}
                        placeholder="Enter Email" />

                      {meta.touched &&
                        meta.error && <div className="error invalid-feedback">{meta.error}</div>}
                    </div>
                  )}
                </Field>

              </div>

              <div className="form-group">
                <p className=" font-weight-bold">Password</p>
                <Field
                  name="password"
                  component={Input}
                  placeholder="Password"
                  label="Password"
                >
                  {({ field, form, meta }) => (
                    <div className="position-relative">
                      <input
                        type={passwordShown ? "text" : "password"}{...field}
                        // type="password" {...field}
                        className={`${getInputClasses(meta)}`}
                        placeholder="Enter Password" />



                      <i
                        className={`fa ${passwordShown ? 'fa-eye-slash' : 'fa-eye'} password-icon`}
                        onClick={togglePasswordVisiblity}
                      />
                      {meta.touched &&
                        meta.error && <div className="error invalid-feedback">{meta.error}</div>}
                    </div>
                  )}
                </Field>

              </div>

              {/* begin::Actions */}
              <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
                <Link to="/auth/forgot-password" className="text-dark-50 text-hover-primary my-3 mr-2" id="kt_login_forgot">
                  <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" />
                </Link>

                <button
                  id="kt_login_signin_submit"
                  type="submit"
                  disabled={isSubmitting}
                  className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
                >
                  <span className={`${loading ? "pr-3" : ""}`}>Sign In</span>
                  {loading && (
                    <span className="spinner-border text-light"></span>
                  )}
                </button>

              </div>
              {/* end::Actions */}
            </form>
          )}
        </Formik>
        {/*end::Form*/}
      </div>

      <Modal centered size="md" show={isShow} onHide={(event) => setIsShow(false)}>
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-lg">Verification</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-0 pb-0">
          <div className="row p-5">
            <p className="m-0 text-center">A code has been sent to your phone number via sms. Please enter that code here.</p>
            <div className="form-group w-100">

              <div className="checkbox justify-content-center d-flex" >

                <OtpInput
                  className="otp"
                  value={OTP}
                  onChange={setOTP}
                  numInputs={6}
                  separator={<span>	</span>}
                />

              </div>

            </div>
            <center>
              <>
                {errorOTP ? (
                  <p style={{ color: "red" }}>Kindly enter correct code</p>
                ) : (
                  ''
                )}
              </>

            </center>
          </div>

        </Modal.Body>
        <Modal.Footer>
          <center>
            <button
              type="button"
              onClick={() => CancelFunction()}
              className="btn btn-light btn-elevate"
            >
              Cancel
            </button>
            <> </>


            <button
              type="submit"
              onClick={() => ApplySettingFunction()}
              className="btn btn-primary float-right"
            >
              {(loading1) ? <i className="fa fa-spinner"></i> : 'Proceed'}
            </button>

          </center>
        </Modal.Footer>
      </Modal>

      {toastDev(toast)}
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
